<template>
  <div>
    <el-upload
        action="#"
        :http-request="uploadSectionFile"
        list-type="picture-card"
        :multiple="multiple"
        ref="upload"
        accept='.jpg, .jpeg, .png, .gif'
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-exceed="fileExceed"
        :limit="multiple?10:1"
        :file-list="imgList"
        :auto-upload="true">
      <div slot="default">
        <i class="el-icon-plus"></i>
        <p>上传图片</p>
      </div>

      <div slot="file" slot-scope="{file}" class="file-img">
        <el-image style="height: 100%;width: 100%"
                  :src="file.url"
                  @click="previewImg(file)"
                  :preview-src-list="urlList">
        </el-image>
        <div class="zhu-tu" v-if="file.isMainPic">
          <i class="el-icon-check"></i>
        </div>
        <div class="img-btn">
          <i class="el-icon-delete" title="删除" @click="handleRemove(file)"></i>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import axios from 'axios';
import {CacheService} from "../../service/common";

export default {
  props:{
    multiple:{
      type:Boolean,
      default:true
    },
    funcName:{
      type:String,
      default:"PayRefund"
    }
  },
  data() {
    return {
      baseURL: this.$fileBaseUrl,
      imgList: [],
      urlList: [],
      saveUrls:[],
      compId:CacheService.get("comp").compId,
    }
  },
  methods: {
    clear(){
      this.imgList.length=0;
      this.urlList.length=0;
      this.saveUrls.length=0;
    },
    previewImg(file) {
      if (!file.id) {
        file.tempurl = this.baseURL + 'x/' + file.response.filePath
      }
      //点击的这张图片的索引
      let index = this.urlList.findIndex(u => file.tempurl === u);
      //目的：把找到的这张图片和后面的，放到最前面
      if (index > 0) {
        this.urlList = this.urlList.slice(index).concat(this.urlList.slice(0, index))
      }
    },
    uploadSectionFile(param) {
      const formdata = new FormData()
      formdata.append('file', param.file)
      /*this.$axios.post(this.$uploadFilePath, formdata).then(res => {
        param.onSuccess(res)
      }, (err) => {
        param.onError(err)
      })*/
      let fileExt1 = param.file.name.substring(param.file.name.lastIndexOf("."));
      let fileExt2 = param.file.name.substring(param.file.name.lastIndexOf(".") + 1);
      let url = `/Yunos/File/MinioUploadURL?fileExt=${fileExt2}&funcName=${this.funcName}`;
      this.$axios.get(url).then((message) => {
        if (message) {
          this.$uaxios.put(message.uploadPath,
              param.file).then((res) => {
            if (res.status === 200) {
              res.filePath = message.filePath;
              res.fileName = param.file.name;
              res.fileExt = fileExt1;
              param.onSuccess(res);
            } else {
              param.onError();
            }
          }, (err) => {
            param.onError(err);
          })
        }
      })
    },
    fileExceed(files, fileList) {
      this.$message.warning(`只能上传${this.multiple?10:1}张图片！`)
    },
    handleZhutu(file) {
      this.imgList.forEach(img => {
        img.isMainPic = 0;
      })
      file.isMainPic = 1;
      this.$emit("setZhu", file)
    },

    beforeUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      const isImage = types.includes(file.type);
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG、GIF 格式!');
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.warning("文件大小不能超过5M!");
        return false
      }
    },
    uploadSuccess(response, file, fileList) {
      this.imgList = fileList;
      this.saveUrls.push(response.filePath)
      this.urlList.push(this.baseURL + 'x/' + response.filePath)
      let newResponse = {
        fileExt: response.fileExt,
        fileName: response.fileName,
        filePath: response.filePath,
        isMainPic: 0,
        name: response.fileName,
        status: "success"
      };
    },
    uploadError(err, file, fileList) {
      this.$message.warning("上传失败！");
    },
    handleRemove(file) {
      let ind = this.imgList.findIndex(f => {
        return f.uid === file.uid;
      })
      ind > -1 && this.imgList.splice(ind, 1)
      this.urlList.forEach((u, index) => {
        if (file.id) {
          if (u === this.baseURL + 'x/' + file.filePath) {
            this.urlList.splice(index, 1)
            this.saveUrls.splice(index,1);
          }
        } else {
          if (u === this.baseURL + 'x/' + file.response.filePath) {
            this.urlList.splice(index, 1)
            this.saveUrls.splice(index,1);
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">

.file-img {
  position: relative;
  height: 100%;

  &:hover {
    .img-btn {
      display: block;
    }
  }
}

.img-btn {
  height: 30px;
  background-color: #7B7B7B;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  display: none;
  opacity: 0.9;

  .el-icon-delete {
    cursor: pointer;
  }
}

::v-deep  {
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    border: 1px solid #dddddd;
    border-radius: 5px;
    line-height: 1.5;
    padding-top: 20px;
  }

  .el-upload--picture-card i {
    font-size: 18px;
    color: #999;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }

  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    border: 1px solid #dddddd;
    border-radius: 15px;
    line-height: 1.5;
    padding-top: 20px;
  }

  .el-upload--picture-card {
    i {
      font-size: 18px;
      color: #999;
    }

    p {
      font-size: 10px;
      color: #999;
    }
  }
}
</style>
